import { render, staticRenderFns } from "./Enrolls.vue?vue&type=template&id=0c225ec8&scoped=true"
import script from "./Enrolls.vue?vue&type=script&lang=js"
export * from "./Enrolls.vue?vue&type=script&lang=js"
import style0 from "./Enrolls.vue?vue&type=style&index=0&id=0c225ec8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c225ec8",
  null
  
)

export default component.exports